import React, { useEffect, useState } from 'react';

import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';

import Laudos from './Laudos';
import Solicitacoes from './Solicitacoes';
import Total from './Total';
import IntlMessage from '../../helpers/intlMessage';

function SolicitacoesContainer () {
  const [currentTab, setCurrentTab] = useState('0');

  useEffect(() => {
    setTimeout(() => setCurrentTab('1'), 200);
  }, []);

  const mudarAba = (event, tab) => setCurrentTab(tab);

  return (
    <div className='mv-solicitacoes-page'>
      <TabContext value={currentTab}>
        <AppBar position='static' color='default'>
          <Tabs
            value={currentTab}
            onChange={mudarAba}
            variant='scrollable'
            indicatorColor='primary'
            textColor='primary'
            aria-label='scrollable force tabs example'
          >
            <Tab icon={<Total />} label={<span style={{ marginRight: '18px' }}>{<IntlMessage id="general.requestsPanel.title" />}</span>} value='1' />
            <Tab
              icon={<i className='tab-icons mv-basico-solicitar'></i>}
              label={<IntlMessage id='general.requestsPanel.request' />}
              value='2'
            />

            <Tab value='0' disabled></Tab>
          </Tabs>
        </AppBar>

        <TabPanel value='0'></TabPanel>

        <TabPanel value='1'>
          <Solicitacoes />
        </TabPanel>
        <TabPanel value='2'>
          <Laudos />
        </TabPanel>
      </TabContext>
    </div>
  );
}

export default SolicitacoesContainer;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/solicitacao.container.js